import VaspForm from './VaspForm'

export default VaspForm
